(() => {
  const body = document.body;
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const siteSearch = document.querySelector('[data-site-search]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = siteSearch?.querySelector('input[type="search"]');
  const toast = document.querySelector('[data-toast]');

  const desktopHover = matchMedia('(hover: hover) and (pointer: fine)');
  const clampDropdownToViewport = (item) => {
    const menu = item.querySelector(':scope > .nav-dropdown > .mega-menu');
    if (!menu) return;
    menu.style.removeProperty('max-width');
    menu.style.removeProperty('margin-left');
    const vw = document.documentElement.clientWidth;
    const r = menu.getBoundingClientRect();
    const pad = 16;
    if (r.right > vw - pad) {
      const maxW = Math.max(280, vw - pad - r.left);
      menu.style.maxWidth = `${maxW}px`;
    }
    if (r.left < pad) {
      const shift = pad - r.left;
      menu.style.marginLeft = `${shift}px`;
      const r2 = menu.getBoundingClientRect();
      if (r2.right > vw - pad) {
        const maxW = Math.max(280, vw - pad - r2.left);
        menu.style.maxWidth = `${maxW}px`;
      }
    }
  };
  const setupDesktopNavHover = () => {
    if (!desktopHover.matches) return;
    document.querySelectorAll('.nav-item.has-children').forEach((item) => {
      const details = item.querySelector(':scope > details.nav-dropdown');
      if (!details) return;
      let closeTimer;
      const openMenu = () => {
        clearTimeout(closeTimer);
        try { details.open = true; } catch (_) {}
        item.classList.add('is-open');
        document.querySelectorAll('.nav-item.has-children > details.nav-dropdown').forEach((other) => {
          if (other !== details) {
            try { other.open = false; } catch (_) {}
            other.closest('.nav-item')?.classList.remove('is-open');
          }
        });
        requestAnimationFrame(() => clampDropdownToViewport(item));
      };
      const closeMenuSoon = () => {
        closeTimer = setTimeout(() => {
          try { details.open = false; } catch (_) {}
          item.classList.remove('is-open');
        }, 150);
      };
      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', closeMenuSoon);
      item.addEventListener('focusin', openMenu);
      item.addEventListener('focusout', closeMenuSoon);
    });
  };
  setupDesktopNavHover();
  desktopHover.addEventListener?.('change', () => window.location.reload());

  const updateHeaderStackHeight = () => {
    const hero = document.querySelector('[data-home-hero]');
    if (!hero) return;
    const headerStackHeight = Math.max(0, Math.round(hero.getBoundingClientRect().top + window.scrollY));
    document.documentElement.style.setProperty('--header-stack-height', `${headerStackHeight}px`);
  };
  let headerMeasureFrame;
  const requestHeaderStackMeasurement = () => {
    cancelAnimationFrame(headerMeasureFrame);
    headerMeasureFrame = requestAnimationFrame(updateHeaderStackHeight);
  };
  requestHeaderStackMeasurement();
  addEventListener('resize', requestHeaderStackMeasurement, { passive: true });
  addEventListener('orientationchange', requestHeaderStackMeasurement, { passive: true });
  document.addEventListener('shopify:section:load', requestHeaderStackMeasurement);
  if ('ResizeObserver' in window) {
    const headerObserver = new ResizeObserver(requestHeaderStackMeasurement);
    document.querySelectorAll('.announcement, .site-header').forEach((element) => headerObserver.observe(element));
  }

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  };
  const setMenu = (open) => {
    body.classList.toggle('menu-open', open);
    menuToggle?.setAttribute('aria-expanded', String(open));
    mobileNav?.setAttribute('aria-hidden', String(!open));
  };
  const setSearch = (open) => {
    if (!siteSearch) return;
    siteSearch.hidden = !open;
    body.classList.toggle('search-open', open);
    searchToggle?.setAttribute('aria-expanded', String(open));
    if (open) {
      setMenu(false);
      requestAnimationFrame(() => searchInput?.focus());
    }
  };
  menuToggle?.addEventListener('click', () => setMenu(!body.classList.contains('menu-open')));
  mobileNav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
  searchToggle?.addEventListener('click', () => setSearch(siteSearch?.hidden));
  searchClose?.addEventListener('click', () => setSearch(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { setMenu(false); setSearch(false); setCartDrawer(false); setFiltersOpen(false); } });

  const predictiveForm = document.querySelector('[data-predictive-search]');
  const predictiveInput = document.querySelector('[data-predictive-search-input]');
  const predictiveResults = document.querySelector('[data-predictive-search-results]');
  let predictiveTimer;
  const clearPredictiveResults = () => {
    if (!predictiveResults) return;
    predictiveResults.innerHTML = '';
    predictiveResults.hidden = true;
  };
  predictiveInput?.addEventListener('input', () => {
    const query = predictiveInput.value.trim();
    clearTimeout(predictiveTimer);
    if (query.length < 2) { clearPredictiveResults(); return; }
    predictiveTimer = setTimeout(async () => {
      try {
        const response = await fetch(`${window.routes?.predictive_search_url || '/search/suggest'}?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=5&section_id=predictive-search`);
        if (!response.ok) throw new Error('Search is temporarily unavailable.');
        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const results = parsed.querySelector('[data-predictive-results]');
        if (!results || query !== predictiveInput.value.trim()) return;
        predictiveResults.innerHTML = results.innerHTML;
        predictiveResults.hidden = !predictiveResults.textContent.trim();
      } catch (error) { clearPredictiveResults(); }
    }, 220);
  });
  predictiveForm?.addEventListener('submit', () => clearPredictiveResults());

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartBody = document.querySelector('[data-cart-drawer-body]');
  const cartFooter = document.querySelector('[data-cart-drawer-footer]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartProgress = document.querySelector('[data-cart-progress]');
  const cartProgressLabel = document.querySelector('[data-cart-progress-label]');
  const cartProgressBar = document.querySelector('[data-cart-progress-bar]');
  const moneyFormatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 });
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));

  const detectBuildPackItemTier = (item = {}) => {
    const explicitTier = item.tier || item.properties?._pricing_tier || '';
    if (['boxer_low', 'boxer_high', 't_shirt', 'lounge_pant'].includes(explicitTier)) return explicitTier;
    const family = String(item.family || '').toLowerCase();
    const combinedText = [
      item.handle,
      item.url,
      item.title,
      item.product_title,
      item.sku
    ].map((v) => String(v || '').toLowerCase()).join(' ');
    const rawPrice = Number(item.singlePricePaise || item.price || item.final_price || 0);
    const pricePaise = rawPrice > 10000 ? Math.round(rawPrice) : Math.round(rawPrice * 100);

    if (family === 'lounge_pants' || combinedText.includes('mlp') || combinedText.includes('pyjama') || combinedText.includes('lounge') || pricePaise >= 50000) {
      return 'lounge_pant';
    }
    if (family === 't_shirts' || combinedText.includes('mts') || combinedText.includes('t-shirt') || combinedText.includes('tshirt') || combinedText.includes('crew neck')) {
      return 't_shirt';
    }
    if (/mbx0?(1[6-9]|2[0-9]|30)(?!\d)/i.test(combinedText) || (pricePaise > 0 && pricePaise <= 36000)) {
      return 'boxer_low';
    }
    return 'boxer_high';
  };

  const calculateBuildPackComboRupees = (nLow, nHigh, nTee, nLounge) => {
    const total = nLow + nHigh + nTee + nLounge;
    const nStd = nHigh + nTee;
    if (total <= 0) return 0;
    if (total === 1) {
      return (nLow * 359) + (nHigh * 399) + (nTee * 399) + (nLounge * 599);
    }
    if (total === 2) {
      if (nLounge === 2) return 999;
      if (nLounge === 1 && nLow === 1) return 849;
      if (nLounge === 1 && nStd === 1) return 899;
      if (nLounge === 0 && nLow === 2) return 649;
      if (nLounge === 0 && nLow === 1 && nStd === 1) return 649;
      if (nLounge === 0 && nStd === 2) return 699;
    }
    if (total === 3) {
      const key = `${nLow},${nHigh},${nTee},${nLounge}`;
      const pack3Table = {
        '3,0,0,0': 879,
        '2,1,0,0': 899,
        '1,2,0,0': 929,
        '0,3,0,0': 949,
        '2,0,1,0': 919,
        '1,1,1,0': 949,
        '0,2,1,0': 969,
        '1,0,2,0': 949,
        '0,1,2,0': 979,
        '0,0,3,0': 999,
        '2,0,0,1': 1079,
        '1,1,0,1': 1099,
        '1,0,1,1': 1099,
        '0,2,0,1': 1129,
        '0,1,1,1': 1149,
        '0,0,2,1': 1149,
        '1,0,0,2': 1249,
        '0,1,0,2': 1299,
        '0,0,1,2': 1299,
        '0,0,0,3': 1449
      };
      if (pack3Table[key] != null) return pack3Table[key];
    }
    return (290 * nLow) + (310 * nHigh) + (330 * nTee) + (480 * nLounge) - 1;
  };

  const calculateBuildPackPricing = (items = []) => {
    let nLow = 0;
    let nHigh = 0;
    let nTee = 0;
    let nLounge = 0;
    let singleTotalPaise = 0;

    items.forEach((item) => {
      const qty = Math.max(1, Number(item.quantity || 1));
      const tier = detectBuildPackItemTier(item);
      const defaultUnitPaise = tier === 'lounge_pant' ? 59900 : tier === 'boxer_low' ? 35900 : 39900;
      const rawUnit = Number(item.singlePricePaise || item.price || item.final_price || defaultUnitPaise);
      const unitPaise = rawUnit > 10000 ? Math.round(rawUnit) : Math.round(rawUnit * 100);
      singleTotalPaise += unitPaise * qty;
      if (tier === 'boxer_low') nLow += qty;
      else if (tier === 't_shirt') nTee += qty;
      else if (tier === 'lounge_pant') nLounge += qty;
      else nHigh += qty;
    });

    const count = nLow + nHigh + nTee + nLounge;
    const comboRupees = calculateBuildPackComboRupees(nLow, nHigh, nTee, nLounge);
    const comboPricePaise = count === 1 ? singleTotalPaise : comboRupees * 100;
    const savingsPaise = Math.max(0, singleTotalPaise - comboPricePaise);

    return {
      count,
      nLow,
      nHigh,
      nTee,
      nLounge,
      singleTotalPaise,
      comboPricePaise,
      savingsPaise
    };
  };

  const setCartDrawer = (open) => {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.setAttribute('aria-hidden', String(!open));
    cartOverlay.hidden = !open;
    body.classList.toggle('cart-open', open);
    document.querySelectorAll('[data-cart-toggle]').forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
    if (open) cartDrawer.querySelector('[data-cart-close]')?.focus();
  };
  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
    if (!cartBody || !cartFooter || !cartSubtotal) return;
    let effectiveCartTotalPaise = cart.total_price;
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="cart-empty"><strong>Your bag is taking a comfort break.</strong><a class="button" href="/collections/all">Shop all products</a></div>';
      cartFooter.hidden = true;
    } else {
      const renderLineItem = (item, index, inBundle = false) => {
        const publicProperties = Object.entries(item.properties || {}).filter(([key, value]) => value && !key.startsWith('_') && key !== 'Pack price');
        const priceMarkup = inBundle
          ? `<span class="cart-line-bundle-included"><small class="cart-line-single-price">${moneyFormatter.format(item.final_line_price / 100)}</small><strong>In Pack</strong></span>`
          : `<strong>${moneyFormatter.format(item.final_line_price / 100)}</strong>`;
        return `<article class="cart-line"><a href="${escapeHtml(item.url)}" tabindex="-1">${item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="">` : ''}</a><div><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : ''}${publicProperties.map(([key, value]) => `<small>${escapeHtml(key)}: ${escapeHtml(value)}</small>`).join('')}<div class="cart-line-actions"><div class="quantity-control"><button type="button" data-cart-change="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div>${priceMarkup}<button type="button" class="cart-remove" data-cart-change="${index + 1}" data-quantity="0">Remove</button></div></div></article>`;
      };
      const groups = new Map();
      const ungrouped = [];
      cart.items.forEach((item, index) => {
        const bundleVal = item.properties?.Bundle;
        const isBuildPack = bundleVal && (bundleVal === 'Build Your Boxer Pack' || String(bundleVal).includes('Build Your Pack'));
        const bundleId = item.properties?._bundle_id || bundleVal;
        if (isBuildPack && bundleId) {
          if (!groups.has(bundleId)) groups.set(bundleId, []);
          groups.get(bundleId).push({ item, index });
        } else if (bundleId && groups.has(bundleId)) {
          groups.get(bundleId).push({ item, index });
        } else {
          ungrouped.push({ item, index });
        }
      });
      const parts = [];
      effectiveCartTotalPaise = 0;
      groups.forEach((entries) => {
        const groupPricing = calculateBuildPackPricing(entries.map(({ item }) => item));
        const size = groupPricing.count;
        effectiveCartTotalPaise += groupPricing.comboPricePaise;
        const priceSummaryHtml = `<span class="cart-bundle-pricing">${groupPricing.savingsPaise > 0 ? `<s class="cart-bundle-compare">${moneyFormatter.format(groupPricing.singleTotalPaise / 100)}</s>` : ''}<strong>${moneyFormatter.format(groupPricing.comboPricePaise / 100)}</strong>${groupPricing.savingsPaise > 0 ? `<small class="cart-bundle-save">Save ${moneyFormatter.format(groupPricing.savingsPaise / 100)}</small>` : ''}</span>`;
        parts.push(`<div class="cart-bundle-group"><div class="cart-bundle-header"><h3 class="cart-bundle-title">Build Your Pack <small>Pack size: ${size} items</small></h3>${priceSummaryHtml}</div>${entries.map(({ item, index }) => renderLineItem(item, index, true)).join('')}</div>`);
      });
      ungrouped.forEach(({ item, index }) => {
        effectiveCartTotalPaise += Number(item.final_line_price || 0);
        parts.push(renderLineItem(item, index, false));
      });
      cartBody.innerHTML = parts.join('');
      cartSubtotal.textContent = moneyFormatter.format(effectiveCartTotalPaise / 100);
      cartFooter.hidden = false;
      const cartPageSubtotal = document.querySelector('.cart-page-summary p strong');
      if (cartPageSubtotal) cartPageSubtotal.textContent = moneyFormatter.format(effectiveCartTotalPaise / 100);
    }
    const threshold = Number(window.themeSettings?.freeShippingThreshold || 0);
    if (cartProgress && cartProgressLabel && cartProgressBar && threshold > 0 && cart.items.length) {
      cartProgress.hidden = false;
      const remaining = Math.max(0, threshold - effectiveCartTotalPaise);
      cartProgressLabel.textContent = remaining > 0 ? `${moneyFormatter.format(remaining / 100)} away from free shipping` : 'Free shipping unlocked';
      cartProgressBar.style.width = `${Math.min(100, effectiveCartTotalPaise / threshold * 100)}%`;
    } else if (cartProgress) cartProgress.hidden = true;
  };
  const refreshCart = async () => {
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());
    renderCart(cart);
    return cart;
  };
  if (document.querySelector('.cart-page-summary')) {
    refreshCart().catch(() => {});
  }
  document.querySelectorAll('[data-cart-toggle]').forEach((toggle) => toggle.addEventListener('click', async (event) => {
    event.preventDefault();
    await refreshCart();
    setCartDrawer(true);
  }));
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => setCartDrawer(false));
  cartOverlay?.addEventListener('click', () => setCartDrawer(false));
  cartBody?.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-cart-change]');
    if (!control) return;
    control.disabled = true;
    const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(control.dataset.cartChange), quantity: Number(control.dataset.quantity) }) });
    if (response.ok) renderCart(await response.json());
    else showToast('Unable to update your bag right now.');
  });

  const addVariant = async (variantId, quantity = 1) => {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(variantId), quantity }) });
    if (!response.ok) throw new Error('Unable to add this item right now.');
    const cart = await fetch('/cart.js').then((result) => result.json());
    renderCart(cart);
    showToast('Added to your comfort queue.');
    setCartDrawer(true);
  };
  document.querySelectorAll('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await addVariant(button.dataset.variantId); } catch (error) { showToast(error.message); }
    button.disabled = false;
  }));

  const syncVariantInputs = (variantId) => {
    document.querySelectorAll('[data-variant-input], [data-variant-input-sticky]').forEach((input) => { input.value = variantId; });
  };
  const syncPriceLabels = (priceText, compareText, discountText) => {
    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice && priceText) stickyPrice.textContent = priceText;
  };
  document.querySelectorAll('[data-size-options]').forEach((fieldset) => {
    fieldset.addEventListener('change', (event) => {
      const radio = event.target.closest('input[type="radio"]');
      if (!radio) return;
      const variantId = radio.value;
      if (!variantId) return;
      syncVariantInputs(variantId);
      document.querySelectorAll('[data-size-options] input[type="radio"]').forEach((r) => {
        if (r.closest('fieldset') !== fieldset) r.checked = r.value === variantId;
      });
    });
  });
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const variantId = select.value;
      syncVariantInputs(variantId);
      const opt = select.options[select.selectedIndex];
      syncPriceLabels(opt?.dataset.variantPrice, opt?.dataset.variantCompare);
    });
  });
  const addProductFormHandler = (form) => {
    if (!form) return;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      try { await addVariant(new FormData(form).get('id')); } catch (error) { showToast(error.message); }
      submit.disabled = false;
    });
  };
  document.querySelectorAll('[data-product-form], [data-product-form-sticky]').forEach(addProductFormHandler);

  const mysteryPopup = document.querySelector('[data-mystery-popup]');
  if (mysteryPopup) {
    const delay = parseInt(mysteryPopup.dataset.delay || '10000', 10);
    const closeBtn = mysteryPopup.querySelector('[data-mystery-popup-close]');
    const closePopup = () => {
      try { mysteryPopup.close(); } catch (_) { mysteryPopup.removeAttribute('open'); }
      try { sessionStorage.setItem('bc_mystery_popup_dismissed', '1'); } catch (_) {}
    };
    closeBtn?.addEventListener('click', closePopup);
    mysteryPopup.addEventListener('click', (e) => {
      if (e.target === mysteryPopup) closePopup();
    });
    const alreadyDismissed = (() => {
      try { return sessionStorage.getItem('bc_mystery_popup_dismissed') === '1'; } catch (_) { return false; }
    })();
    if (!alreadyDismissed) {
      setTimeout(() => {
        if (typeof mysteryPopup.showModal === 'function' && !sessionStorage.getItem('bc_mystery_popup_dismissed')) {
          try { mysteryPopup.showModal(); } catch (_) {}
        }
      }, Math.max(2000, delay));
    }
  }

  const pdpSticky = document.querySelector('[data-pdp-sticky]');
  if (pdpSticky) {
    const mainAtc = document.querySelector('[data-add-to-bag-main]');
    const showStickyThreshold = () => {
      if (!mainAtc) return !1;
      const rect = mainAtc.getBoundingClientRect();
      return rect.bottom < 60;
    };
    const stickyObserver = () => {
      const shouldShow = matchMedia('(max-width: 820px)').matches && showStickyThreshold();
      pdpSticky.hidden = !shouldShow;
    };
    addEventListener('scroll', stickyObserver, { passive: true });
    addEventListener('resize', stickyObserver);
    stickyObserver();
  }

  const revealItems = document.querySelectorAll('.reveal');
  revealItems.forEach((item, index) => item.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 55}ms`));
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries, current) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      current.unobserve(entry.target);
    }), { threshold: .12, rootMargin: '0px 0px -35px' });
    revealItems.forEach((item) => observer.observe(item));
  } else revealItems.forEach((item) => item.classList.add('is-visible'));

  const scrollProgress = document.createElement('div');
  scrollProgress.className = 'mobile-scroll-progress';
  scrollProgress.setAttribute('aria-hidden', 'true');
  body.appendChild(scrollProgress);
  let scrollTicking = false;
  const updateScrollProgress = () => {
    const available = document.documentElement.scrollHeight - innerHeight;
    const progress = available > 0 ? Math.min(100, Math.max(0, scrollY / available * 100)) : 0;
    scrollProgress.style.setProperty('--scroll-progress', `${progress}%`);
    scrollTicking = false;
  };
  addEventListener('scroll', () => {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(updateScrollProgress);
  }, { passive: true });
  updateScrollProgress();

  const galleryRoot = document.querySelector('[data-product-gallery]');
  const galleryMain = galleryRoot?.querySelector('[data-gallery-main]');
  const galleryOpen = galleryRoot?.querySelector('[data-gallery-open]');
  const galleryThumbs = galleryRoot?.querySelectorAll('[data-gallery-thumb]') || [];
  const galleryDialog = galleryRoot?.querySelector('[data-gallery-dialog]');
  const galleryDialogImage = galleryDialog?.querySelector('[data-gallery-dialog-image]');
  const galleryDialogStage = galleryDialog?.querySelector('[data-gallery-dialog-stage]');
  const galleryDialogCount = galleryDialog?.querySelector('[data-gallery-dialog-count]');
  let galleryIndex = 0;
  let thumbsContainer = document.querySelector('[data-gallery-thumb-rail]') || document.querySelector('.gallery-thumbs, .product-thumbs');

  const syncGalleryDialog = () => {
    const thumb = galleryThumbs[galleryIndex];
    if (!thumb || !galleryDialogImage) return;
    const dialogSrc = thumb.dataset.dialogSrc || thumb.dataset.galleryThumb;
    if (galleryDialogImage.src !== dialogSrc) {
      galleryDialogImage.src = dialogSrc;
    }
    galleryDialogImage.alt = thumb.dataset.alt || galleryMain?.alt || '';
    galleryDialogStage?.classList.remove('is-zoomed');
    galleryDialogImage.style.removeProperty('transform-origin');
    if (galleryDialogCount) galleryDialogCount.textContent = `${galleryIndex + 1} / ${galleryThumbs.length}`;
  };

  let updateArrowState = () => {};

  const setGalleryIndex = (index, updateMain = true) => {
    if (!galleryThumbs.length) return;
    galleryIndex = ((index % galleryThumbs.length) + galleryThumbs.length) % galleryThumbs.length;
    const thumb = galleryThumbs[galleryIndex];
    if (!thumb) return;

    if (updateMain && galleryMain) {
      const targetSrc = thumb.dataset.galleryThumb;
      if (galleryMain.src !== targetSrc) {
        galleryMain.src = targetSrc;
      }
      galleryMain.removeAttribute('srcset');
      galleryMain.srcset = '';
      galleryMain.alt = thumb.dataset.alt || galleryMain.alt || '';
    }

    galleryThumbs.forEach((item, itemIndex) => {
      const isActive = itemIndex === galleryIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    try {
      thumb.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
    } catch (_) {}

    syncGalleryDialog();
    setTimeout(updateArrowState, 120);
  };

  galleryThumbs.forEach((thumb, index) => {
    if (index === 0) {
      thumb.classList.add('is-active');
      thumb.setAttribute('aria-current', 'true');
    }
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      setGalleryIndex(index);
    });
  });

  const realWrap = document.querySelector('[data-gallery-thumbs-wrap]') || document.querySelector('.gallery-thumbs-wrap');
  if (realWrap && thumbsContainer && galleryThumbs.length > 1) {
    const prevBtn = realWrap.querySelector('[data-gallery-prev], .gallery-prev');
    const nextBtn = realWrap.querySelector('[data-gallery-next], .gallery-next');
    updateArrowState = () => {
      if (!prevBtn || !nextBtn || !thumbsContainer) return;
      const maxScroll = thumbsContainer.scrollWidth - thumbsContainer.clientWidth;
      if (maxScroll <= 4) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        realWrap.style.gridTemplateColumns = '1fr';
        return;
      }
      prevBtn.style.display = '';
      nextBtn.style.display = '';
      realWrap.style.gridTemplateColumns = '';
      const sl = thumbsContainer.scrollLeft;
      prevBtn.disabled = sl <= 2;
      nextBtn.disabled = sl >= maxScroll - 2;
    };
    const getThumbStep = () => {
      const first = galleryThumbs[0];
      if (!first) return 84;
      const style = window.getComputedStyle(first);
      return first.offsetWidth + parseInt(style.marginRight || '0', 10) + parseInt(style.marginLeft || '0', 10) + 10;
    };
    if (prevBtn) prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const step = getThumbStep() * 2;
      thumbsContainer.scrollBy({ left: -step, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const step = getThumbStep() * 2;
      thumbsContainer.scrollBy({ left: step, behavior: 'smooth' });
    });
    thumbsContainer.addEventListener('scroll', () => {
      clearTimeout(updateArrowState.timer);
      updateArrowState.timer = setTimeout(updateArrowState, 50);
    }, { passive: true });
    window.addEventListener('resize', updateArrowState, { passive: true });
    updateArrowState();
  }

  // Touch swipe on main PDP image
  if (galleryMain && galleryThumbs.length > 1) {
    let touchStartX = 0;
    let touchStartY = 0;
    galleryOpen?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
      touchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    galleryOpen?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0].clientX;
      const touchEndY = event.changedTouches[0].clientY;
      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) setGalleryIndex(galleryIndex + 1);
        else setGalleryIndex(galleryIndex - 1);
      }
    }, { passive: true });
  }

  // Automatic smooth desktop hover zoom
  if (galleryOpen && galleryMain) {
    galleryOpen.addEventListener('pointermove', (event) => {
      if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const rect = galleryOpen.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      galleryMain.style.transformOrigin = `${x}% ${y}%`;
      galleryOpen.classList.add('is-hover-zoomed');
    });
    galleryOpen.addEventListener('pointerleave', () => {
      galleryOpen.classList.remove('is-hover-zoomed');
      galleryMain.style.removeProperty('transform-origin');
    });

    // Mobile / desktop click to open high-res pop-up dialog
    galleryOpen.addEventListener('click', (event) => {
      if (!galleryDialog) return;
      // On desktop with fine pointer, allow click to open full dialog as well
      syncGalleryDialog();
      if (typeof galleryDialog.showModal === 'function') galleryDialog.showModal();
      else galleryDialog.setAttribute('open', '');
      body.classList.add('gallery-dialog-open');
    });
  }

  const closeGalleryDialog = () => {
    if (!galleryDialog) return;
    if (typeof galleryDialog.close === 'function' && galleryDialog.open) galleryDialog.close();
    else galleryDialog.removeAttribute('open');
    galleryDialogStage?.classList.remove('is-zoomed');
    galleryDialogImage?.style.removeProperty('transform-origin');
    body.classList.remove('gallery-dialog-open');
  };

  galleryDialog?.querySelector('[data-gallery-close]')?.addEventListener('click', closeGalleryDialog);
  galleryDialog?.querySelector('[data-gallery-dialog-prev]')?.addEventListener('click', (e) => {
    e.preventDefault();
    setGalleryIndex(galleryIndex - 1, true);
  });
  galleryDialog?.querySelector('[data-gallery-dialog-next]')?.addEventListener('click', (e) => {
    e.preventDefault();
    setGalleryIndex(galleryIndex + 1, true);
  });
  galleryDialog?.addEventListener('click', (event) => {
    if (event.target === galleryDialog) closeGalleryDialog();
  });
  galleryDialog?.addEventListener('close', () => {
    body.classList.remove('gallery-dialog-open');
    galleryDialogStage?.classList.remove('is-zoomed');
  });

  // Mobile Dialog Touch Swipe Navigation
  if (galleryDialogStage) {
    let dialogTouchStartX = 0;
    let dialogTouchStartY = 0;
    galleryDialogStage.addEventListener('touchstart', (event) => {
      if (galleryDialogStage.classList.contains('is-zoomed')) return; // Allow panning when zoomed
      dialogTouchStartX = event.changedTouches[0].clientX;
      dialogTouchStartY = event.changedTouches[0].clientY;
    }, { passive: true });
    galleryDialogStage.addEventListener('touchend', (event) => {
      if (galleryDialogStage.classList.contains('is-zoomed')) return;
      const dialogTouchEndX = event.changedTouches[0].clientX;
      const dialogTouchEndY = event.changedTouches[0].clientY;
      const deltaX = dialogTouchEndX - dialogTouchStartX;
      const deltaY = dialogTouchEndY - dialogTouchStartY;
      if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
        if (deltaX < 0) setGalleryIndex(galleryIndex + 1, true);
        else setGalleryIndex(galleryIndex - 1, true);
      }
    }, { passive: true });
  }

  // Dialog Double-click / Double-tap to zoom
  let galleryLastTap = 0;
  const toggleDialogZoom = (event) => {
    if (!galleryDialogStage || !galleryDialogImage) return;
    const zoomed = galleryDialogStage.classList.toggle('is-zoomed');
    if (zoomed && event) {
      const rect = galleryDialogImage.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / Math.max(1, rect.width)) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / Math.max(1, rect.height)) * 100));
      galleryDialogImage.style.transformOrigin = `${x}% ${y}%`;
    } else {
      galleryDialogImage.style.removeProperty('transform-origin');
    }
  };

  galleryDialogStage?.addEventListener('dblclick', toggleDialogZoom);
  galleryDialogStage?.addEventListener('touchend', (event) => {
    const now = Date.now();
    if (now - galleryLastTap < 320) {
      event.preventDefault();
      const touch = event.changedTouches[0];
      toggleDialogZoom({ clientX: touch.clientX, clientY: touch.clientY });
      galleryLastTap = 0;
    } else {
      galleryLastTap = now;
    }
  }, { passive: false });

  document.querySelectorAll('a[href="#size"]').forEach((link) => link.addEventListener('click', (event) => {
    const sizeGuide = document.querySelector('details#size');
    if (!sizeGuide) return;
    event.preventDefault();
    sizeGuide.open = true;
    sizeGuide.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }));

  document.querySelectorAll('[data-review-filter]').forEach((button) => button.addEventListener('click', () => {
    const reviewPage = button.closest('[data-review-page]');
    if (!reviewPage) return;
    const source = button.dataset.reviewFilter;
    reviewPage.querySelectorAll('[data-review-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
    reviewPage.querySelectorAll('[data-review-source]').forEach((card) => { card.hidden = source !== 'all' && card.dataset.reviewSource !== source; });
    window.dataLayer?.push({ event: 'review_source_filter', review_source: source });
  }));

  const setFiltersOpen = (open) => {
    const filterForm = document.querySelector('#FacetFiltersForm');
    const filterToggle = document.querySelector('[data-filter-toggle]');
    const filterOverlay = document.querySelector('[data-filter-overlay]');
    if (!filterForm || !filterToggle) return;
    filterForm.classList.toggle('is-open', open);
    body.classList.toggle('filters-open', open);
    filterToggle.setAttribute('aria-expanded', String(open));
    if (filterOverlay) { filterOverlay.hidden = !open; }
    if (open) {
      filterForm.style.setProperty('--drawer-top', `${(document.querySelector('.site-header')?.getBoundingClientRect().bottom || 100) + 6}px`);
    }
  };
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-filter-toggle]')) {
      const filterForm = document.querySelector('#FacetFiltersForm');
      setFiltersOpen(!filterForm?.classList.contains('is-open'));
    }
    if (event.target.closest('[data-filter-close]')) setFiltersOpen(false);
    if (event.target.closest('[data-filter-overlay]')) setFiltersOpen(false);
  });

  document.addEventListener('change', (event) => {
    const sortSelect = event.target.closest('[data-collection-sort]');
    if (!sortSelect) return;
    const url = new URL(window.location.href);
    const value = sortSelect.value;
    if (value) url.searchParams.set('sort_by', value); else url.searchParams.delete('sort_by');
    window.location.href = url.toString();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const filterForm = document.querySelector('#FacetFiltersForm');
      if (filterForm?.classList.contains('is-open')) setFiltersOpen(false);
    }
  });

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details || !details.matches('details.filter-group')) return;
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', String(details.open));
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('details.filter-group').forEach((det) => {
      const summary = det.querySelector(':scope > summary');
      if (summary && summary.getAttribute('aria-expanded') === null) {
        summary.setAttribute('aria-expanded', String(det.open));
      }
    });
  });

  // ==========================================================================
  // BOXY CREW — REBUILT COLLECTION FILTER & SORT SYSTEM
  // ==========================================================================
  const initCollectionFilters = () => {
    const grid = document.querySelector('[data-product-grid], .product-grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.product-card'));
    if (!cards.length) return;

    const drawer = document.querySelector('[data-filter-drawer]');
    const backdrop = document.querySelector('[data-filter-backdrop]');
    const openBtn = document.querySelector('[data-open-filters]');
    const closeBtn = document.querySelector('[data-close-filters]');
    const applyBtn = document.querySelector('[data-apply-filters]');
    const clearBtns = document.querySelectorAll('[data-clear-all-filters]');
    const filterBadge = document.querySelector('[data-filter-badge]');
    const countNum = document.querySelector('[data-count-num]');
    const countLabel = document.querySelector('[data-count-label]');
    const applyCount = document.querySelector('[data-apply-count]');
    const emptyState = document.querySelector('[data-collection-empty]');
    const quickChips = document.querySelectorAll('[data-quick-filter]');
    const activeChipsBar = document.querySelector('[data-active-chips-bar]');
    const activeChipsTrack = document.querySelector('[data-active-chips-track]');
    const sortWrapper = document.querySelector('[data-sort-dropdown-wrap]');
    const sortTrigger = document.querySelector('[data-sort-trigger]');
    const sortMenu = document.querySelector('[data-sort-menu]');
    const sortOptions = document.querySelectorAll('.sort-option-btn');

    const sliderWrap = document.querySelector('[data-price-slider-wrap]');
    const rangeMin = sliderWrap ? sliderWrap.querySelector('[data-range-min]') : null;
    const rangeMax = sliderWrap ? sliderWrap.querySelector('[data-range-max]') : null;
    const sliderFill = sliderWrap ? sliderWrap.querySelector('[data-slider-fill]') : null;
    const priceMinLabel = sliderWrap ? sliderWrap.querySelector('[data-price-min-label]') : null;
    const priceMaxLabel = sliderWrap ? sliderWrap.querySelector('[data-price-max-label]') : null;

    // Card parser
    const parseCard = (card, idx) => {
      let sizes = [];
      try {
        const raw = card.dataset.sizes || '[]';
        sizes = JSON.parse(raw);
        if (!Array.isArray(sizes)) sizes = [];
      } catch (_) {
        sizes = [];
      }
      sizes = sizes.map(s => String(s).trim().toLowerCase());

      let price = parseFloat(card.dataset.price || '0');
      if (price > 10000) price = price / 100;

      return {
        card,
        initialIndex: idx,
        id: card.dataset.productId || String(idx),
        category: (card.dataset.category || '').trim().toLowerCase(),
        sizes,
        colour: (card.dataset.colour || '').trim().toLowerCase(),
        pf: (card.dataset.pf || '').trim().toLowerCase(),
        waistband: (card.dataset.waistband || '').trim().toLowerCase(),
        price,
        available: card.dataset.available === 'true',
        createdAt: card.dataset.createdAt || ''
      };
    };

    // Parsed product inventory
    let products = cards.map(parseCard);

    // Discrete Price Ladder setup from assortment
    let priceLadder = [];
    const assortmentPrices = Array.from(new Set(products.map(p => Math.round(p.price)).filter(p => p > 0))).sort((a, b) => a - b);
    if (assortmentPrices.length >= 2) {
      priceLadder = assortmentPrices;
    } else if (sliderWrap && sliderWrap.dataset.priceLadder) {
      priceLadder = sliderWrap.dataset.priceLadder
        .split(',')
        .map(v => parseInt(v.trim(), 10))
        .filter(n => !isNaN(n))
        .sort((a, b) => a - b);
    }

    if (sliderWrap) {
      if (priceLadder.length >= 2) {
        if (rangeMin) {
          rangeMin.min = 0;
          rangeMin.max = priceLadder.length - 1;
        }
        if (rangeMax) {
          rangeMax.min = 0;
          rangeMax.max = priceLadder.length - 1;
          rangeMax.value = priceLadder.length - 1;
        }
        const bounds = sliderWrap.querySelector('.price-slider-bounds');
        if (bounds) {
          bounds.innerHTML = `<span>₹${priceLadder[0]}</span><span>₹${priceLadder[priceLadder.length - 1]}</span>`;
        }
      } else {
        const priceAccordion = drawer ? drawer.querySelector('[data-filter-group="price"]') : null;
        if (priceAccordion) priceAccordion.hidden = true;
        const priceQuickChip = document.querySelector('[data-quick-filter="price"]');
        if (priceQuickChip) priceQuickChip.hidden = true;
      }
    }

    // Active state
    let activeSort = 'manual';

    // Drawer open / close
    const openDrawer = (targetGroup = null) => {
      if (!drawer) return;
      document.body.classList.add('filters-open');
      drawer.removeAttribute('hidden');
      if (backdrop) backdrop.removeAttribute('hidden');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');

      if (targetGroup) {
        const targetAccordion = drawer.querySelector(`[data-filter-group="${targetGroup}"]`);
        if (targetAccordion) {
          targetAccordion.open = true;
          setTimeout(() => {
            targetAccordion.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            const firstInput = targetAccordion.querySelector('input, button');
            if (firstInput) firstInput.focus();
          }, 150);
        }
      }
    };

    const closeDrawer = () => {
      if (!drawer) return;
      document.body.classList.remove('filters-open');
      drawer.setAttribute('hidden', '');
      if (backdrop) backdrop.setAttribute('hidden', '');
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      }
    };

    if (openBtn) openBtn.addEventListener('click', () => openDrawer());
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        closeDrawer();
        const toolbar = document.querySelector('[data-collection-sticky-bar]');
        if (toolbar) {
          toolbar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Quick chips click handling (opens drawer)
    quickChips.forEach(chip => {
      chip.addEventListener('click', () => {
        const group = chip.dataset.quickFilter;
        openDrawer(group);
      });
    });

    // Quick toggle chips handling (direct toggle without opening drawer)
    const quickToggleChips = document.querySelectorAll('[data-quick-toggle]');
    quickToggleChips.forEach(chip => {
      chip.addEventListener('click', (e) => {
        e.preventDefault();
        const parts = (chip.dataset.quickToggle || '').split(':');
        if (parts.length < 2) return;
        const [group, val] = parts;
        let selector = '';
        if (group === 'category') selector = '[data-filter-category]';
        else if (group === 'waistband') selector = '[data-filter-waistband]';
        else if (group === 'pf') selector = '[data-filter-pf]';
        else if (group === 'size') selector = '[data-filter-size]';

        if (selector && drawer) {
          const inputs = Array.from(drawer.querySelectorAll(selector));
          const targetInput = inputs.find(i => {
            const v = i.value.toLowerCase();
            const q = val.toLowerCase();
            if (q.includes('no-mark') || q.includes('no_mark') || q.includes('nomark')) {
              return v.includes('no-mark') || v.includes('no_mark') || v.includes('nomark');
            }
            if (q.includes('regular')) return v.includes('regular');
            if (q.includes('2')) return v.includes('2');
            if (q.includes('3')) return v.includes('3');
            if (q.includes('5')) return v.includes('5');
            if (q.includes('single')) return v.includes('single');
            return v === q;
          });
          if (targetInput) {
            targetInput.checked = !targetInput.checked;
            applyFiltersAndSort(true);
          }
        }
      });
    });

    // ESC key closes drawer & sort menu
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        if (document.body.classList.contains('filters-open')) {
          closeDrawer();
        }
        if (sortMenu && !sortMenu.hasAttribute('hidden')) {
          closeSortMenu();
        }
      }
    });

    // Sort menu toggle
    const toggleSortMenu = () => {
      if (!sortMenu) return;
      const isHidden = sortMenu.hasAttribute('hidden');
      if (isHidden) {
        sortMenu.removeAttribute('hidden');
        if (sortWrapper) sortWrapper.classList.add('is-open');
        if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'true');
      } else {
        closeSortMenu();
      }
    };

    const closeSortMenu = () => {
      if (!sortMenu) return;
      sortMenu.setAttribute('hidden', '');
      if (sortWrapper) sortWrapper.classList.remove('is-open');
      if (sortTrigger) sortTrigger.setAttribute('aria-expanded', 'false');
    };

    if (sortTrigger) {
      sortTrigger.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleSortMenu();
      });
    }

    document.addEventListener('click', (e) => {
      if (sortWrapper && !sortWrapper.contains(e.target)) {
        closeSortMenu();
      }
    });

    sortOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        activeSort = opt.dataset.sortVal;
        sortOptions.forEach(o => {
          const isActive = o === opt;
          o.classList.toggle('is-active', isActive);
          o.setAttribute('aria-selected', String(isActive));
        });
        closeSortMenu();
        applyFiltersAndSort(true);
      });
    });

    // Price slider updates
    const updateSliderUI = () => {
      if (!rangeMin || !rangeMax || priceLadder.length < 2) return;
      let minIdx = parseInt(rangeMin.value, 10);
      let maxIdx = parseInt(rangeMax.value, 10);

      if (minIdx > maxIdx) {
        minIdx = maxIdx;
        rangeMin.value = minIdx;
      }

      const totalSteps = priceLadder.length - 1;
      const minPct = (minIdx / totalSteps) * 100;
      const maxPct = (maxIdx / totalSteps) * 100;

      if (sliderFill) {
        sliderFill.style.left = `${minPct}%`;
        sliderFill.style.width = `${maxPct - minPct}%`;
      }

      if (priceMinLabel) priceMinLabel.textContent = `₹${priceLadder[minIdx]}`;
      if (priceMaxLabel) priceMaxLabel.textContent = `₹${priceLadder[maxIdx]}`;
    };

    if (rangeMin && rangeMax && priceLadder.length >= 2) {
      rangeMin.addEventListener('input', () => {
        if (parseInt(rangeMin.value, 10) > parseInt(rangeMax.value, 10)) {
          rangeMin.value = rangeMax.value;
        }
        updateSliderUI();
        applyFiltersAndSort(true);
      });

      rangeMax.addEventListener('input', () => {
        if (parseInt(rangeMax.value, 10) < parseInt(rangeMin.value, 10)) {
          rangeMax.value = rangeMin.value;
        }
        updateSliderUI();
        applyFiltersAndSort(true);
      });
    }

    // Read current filter state from inputs
    const getFilterState = () => {
      const getChecked = (selector) =>
        Array.from(drawer ? drawer.querySelectorAll(`${selector}:checked`) : [])
          .map(el => el.value.trim().toLowerCase());

      const categories = getChecked('[data-filter-category]');
      const sizes = getChecked('[data-filter-size]');
      const colours = getChecked('[data-filter-colour]');
      const packTypes = getChecked('[data-filter-pf]');
      const waistbands = getChecked('[data-filter-waistband]');
      const availability = getChecked('[data-filter-avail]');

      let minPrice = -Infinity;
      let maxPrice = Infinity;
      let priceFiltered = false;

      if (rangeMin && rangeMax && priceLadder.length >= 2) {
        const minIdx = parseInt(rangeMin.value, 10);
        const maxIdx = parseInt(rangeMax.value, 10);
        minPrice = priceLadder[minIdx];
        maxPrice = priceLadder[maxIdx];
        if (minIdx > 0 || maxIdx < priceLadder.length - 1) {
          priceFiltered = true;
        }
      }

      return {
        categories,
        sizes,
        colours,
        packTypes,
        waistbands,
        availability,
        minPrice,
        maxPrice,
        priceFiltered,
        sort: activeSort
      };
    };

    // Product match testing
    const matchProduct = (p, state, excludeGroup = null) => {
      // Category
      if (excludeGroup !== 'category' && state.categories.length > 0) {
        if (!state.categories.some(c => p.category === c || p.category.includes(c) || c.includes(p.category))) {
          return false;
        }
      }

      // Size
      if (excludeGroup !== 'size' && state.sizes.length > 0) {
        if (!state.sizes.some(s => p.sizes.includes(s))) {
          return false;
        }
      }

      // Colour
      if (excludeGroup !== 'colour' && state.colours.length > 0) {
        if (!state.colours.some(c => p.colour.includes(c) || c.includes(p.colour))) {
          return false;
        }
      }

      // Pack Type
      if (excludeGroup !== 'pack_type' && state.packTypes.length > 0) {
        const matchesPf = state.packTypes.some(pt => {
          if (pt.includes('2')) return p.pf.includes('2');
          if (pt.includes('3')) return p.pf.includes('3');
          if (pt.includes('5')) return p.pf.includes('5');
          if (pt.includes('single')) return p.pf.includes('single');
          return p.pf === pt;
        });
        if (!matchesPf) return false;
      }

      // Waistband Type
      if (excludeGroup !== 'waistband' && state.waistbands.length > 0) {
        const matchesWb = state.waistbands.some(wb => {
          if (wb.includes('no-mark') || wb.includes('no_mark') || wb.includes('nomark')) {
            return p.waistband.includes('no-mark') || p.waistband.includes('no_mark') || p.waistband.includes('nomark');
          }
          if (wb.includes('regular')) {
            return p.waistband.includes('regular');
          }
          return p.waistband === wb;
        });
        if (!matchesWb) return false;
      }

      // Price
      if (excludeGroup !== 'price' && state.priceFiltered) {
        if (p.price < state.minPrice || p.price > state.maxPrice) {
          return false;
        }
      }

      // Availability
      if (excludeGroup !== 'availability' && state.availability.length > 0) {
        if (state.availability.includes('in_stock') && !p.available) {
          return false;
        }
      }

      return true;
    };

    // Recalculate dynamic facet counts for all options in drawer
    const updateFacetCounts = (state) => {
      if (!drawer) return;

      // Helper for checkbox counts
      const updateGroupCounts = (selector, countAttr, groupName, testFn) => {
        const inputs = drawer.querySelectorAll(selector);
        inputs.forEach(input => {
          const val = input.value.trim().toLowerCase();
          const count = products.reduce((acc, p) => {
            if (matchProduct(p, state, groupName) && testFn(p, val)) {
              return acc + 1;
            }
            return acc;
          }, 0);

          const countEl = drawer.querySelector(`[${countAttr}="${CSS.escape(input.value)}"]`);
          if (countEl) countEl.textContent = `(${count})`;

          const label = input.closest('label');
          if (label) {
            const isDisabled = count === 0 && !input.checked;
            label.classList.toggle('is-disabled', isDisabled);
            input.disabled = isDisabled;
          }
        });
      };

      // Category
      updateGroupCounts('[data-filter-category]', 'data-count-for-category', 'category', (p, val) =>
        p.category === val || p.category.includes(val) || val.includes(p.category)
      );

      // Size
      updateGroupCounts('[data-filter-size]', 'data-count-for-size', 'size', (p, val) =>
        p.sizes.includes(val)
      );

      // Colour
      updateGroupCounts('[data-filter-colour]', 'data-count-for-colour', 'colour', (p, val) =>
        p.colour.includes(val) || val.includes(p.colour)
      );

      // Pack Type
      updateGroupCounts('[data-filter-pf]', 'data-count-for-pf', 'pack_type', (p, val) => {
        if (val.includes('2')) return p.pf.includes('2');
        if (val.includes('3')) return p.pf.includes('3');
        if (val.includes('5')) return p.pf.includes('5');
        if (val.includes('single')) return p.pf.includes('single');
        return p.pf === val;
      });

      // Waistband
      updateGroupCounts('[data-filter-waistband]', 'data-count-for-wb', 'waistband', (p, val) => {
        if (val.includes('no-mark') || val.includes('no_mark') || val.includes('nomark')) {
          return p.waistband.includes('no-mark') || p.waistband.includes('no_mark') || p.waistband.includes('nomark');
        }
        if (val.includes('regular')) return p.waistband.includes('regular');
        return p.waistband === val;
      });

      // Availability (In Stock)
      const availInputs = drawer.querySelectorAll('[data-filter-avail]');
      availInputs.forEach(input => {
        const count = products.reduce((acc, p) => {
          if (matchProduct(p, state, 'availability') && p.available) {
            return acc + 1;
          }
          return acc;
        }, 0);
        const countEl = drawer.querySelector('[data-count-for-avail="in_stock"]');
        if (countEl) countEl.textContent = `(${count})`;
      });
    };

    // Render active chips
    const renderActiveChips = (state) => {
      if (!activeChipsBar || !activeChipsTrack) return;

      const chips = [];

      state.categories.forEach(c => {
        const input = drawer.querySelector(`[data-filter-category][value="${CSS.escape(c)}" i]`);
        chips.push({
          group: 'Category',
          label: input ? input.value : c,
          clear: () => { if (input) { input.checked = false; applyFiltersAndSort(true); } }
        });
      });

      state.sizes.forEach(s => {
        const input = drawer.querySelector(`[data-filter-size][value="${CSS.escape(s)}" i]`);
        chips.push({
          group: 'Size',
          label: input ? input.value : s.toUpperCase(),
          clear: () => { if (input) { input.checked = false; applyFiltersAndSort(true); } }
        });
      });

      state.colours.forEach(col => {
        const input = drawer.querySelector(`[data-filter-colour][value="${CSS.escape(col)}" i]`);
        chips.push({
          group: 'Color',
          label: input ? input.value : col,
          clear: () => { if (input) { input.checked = false; applyFiltersAndSort(true); } }
        });
      });

      state.packTypes.forEach(pt => {
        const input = drawer.querySelector(`[data-filter-pf][value="${CSS.escape(pt)}" i]`);
        chips.push({
          group: 'Pack',
          label: input ? input.value : pt,
          clear: () => { if (input) { input.checked = false; applyFiltersAndSort(true); } }
        });
      });

      state.waistbands.forEach(wb => {
        const input = drawer.querySelector(`[data-filter-waistband][value="${CSS.escape(wb)}" i]`);
        chips.push({
          group: 'Waistband',
          label: input ? input.value : wb,
          clear: () => { if (input) { input.checked = false; applyFiltersAndSort(true); } }
        });
      });

      if (state.availability.includes('in_stock')) {
        const input = drawer.querySelector('[data-filter-avail][value="in_stock"]');
        chips.push({
          group: 'Availability',
          label: 'In Stock',
          clear: () => { if (input) { input.checked = false; applyFiltersAndSort(true); } }
        });
      }

      if (state.priceFiltered) {
        chips.push({
          group: 'Price',
          label: `₹${state.minPrice} – ₹${state.maxPrice}`,
          clear: () => {
            if (rangeMin && rangeMax) {
              rangeMin.value = 0;
              rangeMax.value = priceLadder.length - 1;
              updateSliderUI();
              applyFiltersAndSort(true);
            }
          }
        });
      }

      // Update badge
      if (filterBadge) {
        if (chips.length > 0) {
          filterBadge.textContent = String(chips.length);
          filterBadge.removeAttribute('hidden');
        } else {
          filterBadge.setAttribute('hidden', '');
        }
      }

      // Update quick chips highlight
      quickChips.forEach(qc => {
        const g = qc.dataset.quickFilter;
        let isActive = false;
        if (g === 'category' && state.categories.length > 0) isActive = true;
        if (g === 'size' && state.sizes.length > 0) isActive = true;
        if (g === 'colour' && state.colours.length > 0) isActive = true;
        if (g === 'pack_type' && state.packTypes.length > 0) isActive = true;
        if (g === 'waistband' && state.waistbands.length > 0) isActive = true;
        if (g === 'price' && state.priceFiltered) isActive = true;
        qc.classList.toggle('is-active', isActive);
      });

      // Update quick toggle chips highlight
      quickToggleChips.forEach(chip => {
        const parts = (chip.dataset.quickToggle || '').split(':');
        if (parts.length < 2) return;
        const [group, val] = parts;
        const valLower = val.toLowerCase();
        let isActive = false;
        if (group === 'category') isActive = state.categories.includes(valLower);
        else if (group === 'waistband') {
          isActive = state.waistbands.some(w => {
            if (valLower.includes('no-mark')) return w.includes('no-mark') || w.includes('no_mark') || w.includes('nomark');
            if (valLower.includes('regular')) return w.includes('regular');
            return w === valLower;
          });
        } else if (group === 'pf') {
          isActive = state.packTypes.some(p => {
            if (valLower.includes('2')) return p.includes('2');
            if (valLower.includes('3')) return p.includes('3');
            if (valLower.includes('5')) return p.includes('5');
            if (valLower.includes('single')) return p.includes('single');
            return p === valLower;
          });
        }
        chip.classList.toggle('is-active', isActive);
        chip.setAttribute('aria-pressed', String(isActive));
      });

      // Render track
      activeChipsTrack.innerHTML = '';
      if (chips.length > 0) {
        activeChipsBar.removeAttribute('hidden');
        chips.forEach(c => {
          const chipEl = document.createElement('span');
          chipEl.className = 'active-chip';
          chipEl.innerHTML = `
            <span class="active-chip-label"><span class="active-chip-group">${escapeHtml(c.group)}:</span> ${escapeHtml(c.label)}</span>
            <button type="button" class="active-chip-remove" aria-label="Remove filter ${escapeHtml(c.label)}">×</button>
          `;
          chipEl.querySelector('.active-chip-remove').addEventListener('click', c.clear);
          activeChipsTrack.appendChild(chipEl);
        });
      } else {
        activeChipsBar.setAttribute('hidden', '');
      }
    };

    // Sort comparator
    const getSortComparator = (sortType) => {
      switch (sortType) {
        case 'created-descending':
          return (a, b) => (b.createdAt > a.createdAt ? 1 : b.createdAt < a.createdAt ? -1 : b.id.localeCompare(a.id));
        case 'price-ascending':
          return (a, b) => a.price - b.price || a.initialIndex - b.initialIndex;
        case 'price-descending':
          return (a, b) => b.price - a.price || a.initialIndex - b.initialIndex;
        case 'manual':
        default:
          return (a, b) => a.initialIndex - b.initialIndex;
      }
    };

    // URL sync
    const syncURL = (state) => {
      const params = new URLSearchParams(window.location.search);

      // Clean old params
      ['category', 'size', 'colour', 'pack_type', 'waistband', 'in_stock', 'price_min', 'price_max', 'sort'].forEach(k => params.delete(k));

      if (state.categories.length > 0) params.set('category', state.categories.join(','));
      if (state.sizes.length > 0) params.set('size', state.sizes.join(','));
      if (state.colours.length > 0) params.set('colour', state.colours.join(','));
      if (state.packTypes.length > 0) params.set('pack_type', state.packTypes.join(','));
      if (state.waistbands.length > 0) params.set('waistband', state.waistbands.join(','));
      if (state.availability.includes('in_stock')) params.set('in_stock', '1');
      if (state.priceFiltered) {
        params.set('price_min', String(state.minPrice));
        params.set('price_max', String(state.maxPrice));
      }
      if (state.sort && state.sort !== 'manual') params.set('sort', state.sort);

      const qs = params.toString();
      const newUrl = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`;
      window.history.replaceState(null, '', newUrl);
    };

    // Main Filter & Sort Execution
    const applyFiltersAndSort = (shouldSyncURL = false) => {
      const state = getFilterState();

      let visibleCount = 0;
      const visibleProducts = [];

      products.forEach(p => {
        const match = matchProduct(p, state);
        p.card.hidden = !match;
        if (match) {
          visibleCount++;
          visibleProducts.push(p);
        }
      });

      // Sort matching products in DOM
      const comparator = getSortComparator(state.sort);
      visibleProducts.sort(comparator);

      const fragment = document.createDocumentFragment();
      visibleProducts.forEach(p => fragment.appendChild(p.card));
      grid.appendChild(fragment);

      // Update toolbar count
      if (countNum) countNum.textContent = String(visibleCount);
      if (countLabel) countLabel.textContent = visibleCount === 1 ? 'PRODUCT' : 'PRODUCTS';
      if (applyCount) applyCount.textContent = String(visibleCount);

      // Empty state
      if (emptyState) {
        emptyState.hidden = visibleCount > 0;
      }

      // Facet counts & active chips
      updateFacetCounts(state);
      renderActiveChips(state);

      if (shouldSyncURL) {
        syncURL(state);
      }
    };

    // Clear all filters
    const clearAllFilters = () => {
      if (drawer) {
        drawer.querySelectorAll('input[type="checkbox"]').forEach(cb => {
          cb.checked = false;
        });
      }
      if (rangeMin && rangeMax && priceLadder.length >= 2) {
        rangeMin.value = 0;
        rangeMax.value = priceLadder.length - 1;
        updateSliderUI();
      }
      applyFiltersAndSort(true);
    };

    clearBtns.forEach(btn => btn.addEventListener('click', clearAllFilters));

    // Listen for checkbox changes in drawer
    if (drawer) {
      drawer.addEventListener('change', (e) => {
        if (e.target.matches('input[type="checkbox"]')) {
          applyFiltersAndSort(true);
        }
      });
    }

    // Restore state from URL on initial load
    const restoreFromURL = () => {
      const params = new URLSearchParams(window.location.search);

      const setCheckboxesFromParam = (paramName, selector) => {
        const val = params.get(paramName);
        if (!val) return;
        const vals = val.split(',').map(v => v.trim().toLowerCase());
        drawer.querySelectorAll(selector).forEach(cb => {
          if (vals.includes(cb.value.trim().toLowerCase())) {
            cb.checked = true;
          }
        });
      };

      if (drawer) {
        setCheckboxesFromParam('category', '[data-filter-category]');
        setCheckboxesFromParam('size', '[data-filter-size]');
        setCheckboxesFromParam('colour', '[data-filter-colour]');
        setCheckboxesFromParam('pack_type', '[data-filter-pf]');
        setCheckboxesFromParam('waistband', '[data-filter-waistband]');

        if (params.get('in_stock') === '1' || params.get('in_stock') === 'true') {
          const availCb = drawer.querySelector('[data-filter-avail][value="in_stock"]');
          if (availCb) availCb.checked = true;
        }

        const pMin = params.get('price_min');
        const pMax = params.get('price_max');
        if (rangeMin && rangeMax && priceLadder.length >= 2 && (pMin || pMax)) {
          if (pMin) {
            const minNum = parseInt(pMin, 10);
            const idx = priceLadder.findIndex(p => p >= minNum);
            if (idx !== -1) rangeMin.value = idx;
          }
          if (pMax) {
            const maxNum = parseInt(pMax, 10);
            const rArr = [...priceLadder].reverse();
            const rIdx = rArr.findIndex(p => p <= maxNum);
            if (rIdx !== -1) rangeMax.value = priceLadder.length - 1 - rIdx;
          }
        }
      }

      const sortVal = params.get('sort');
      if (sortVal) {
        activeSort = sortVal;
        sortOptions.forEach(opt => {
          const isActive = opt.dataset.sortVal === sortVal;
          opt.classList.toggle('is-active', isActive);
          opt.setAttribute('aria-selected', String(isActive));
        });
      }

      updateSliderUI();
      applyFiltersAndSort(false);
    };

    window.addEventListener('popstate', restoreFromURL);

    // Initial run
    restoreFromURL();

    // Auto-load remaining catalog items via background fetch if collection is paginated (e.g. Shop All /collections/all)
    if (grid.dataset.nextUrl) {
      const loadNextCatalogBatch = (url) => {
        fetch(url)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newCardNodes = Array.from(doc.querySelectorAll('.product-grid .product-card'));
            if (newCardNodes.length) {
              const startIdx = products.length;
              newCardNodes.forEach((c, idx) => {
                grid.appendChild(c);
                products.push(parseCard(c, startIdx + idx));
              });

              // Re-setup price ladder if assortment grew
              const newPrices = Array.from(new Set(products.map(p => Math.round(p.price)).filter(p => p > 0))).sort((a, b) => a - b);
              if (newPrices.length >= 2) {
                priceLadder = newPrices;
                if (sliderWrap && rangeMin && rangeMax) {
                  rangeMin.max = priceLadder.length - 1;
                  rangeMax.max = priceLadder.length - 1;
                  rangeMax.value = priceLadder.length - 1;
                  const bounds = sliderWrap.querySelector('.price-slider-bounds');
                  if (bounds) bounds.innerHTML = `<span>₹${priceLadder[0]}</span><span>₹${priceLadder[priceLadder.length - 1]}</span>`;
                }
              }

              // Hide server pagination controls since all items are loaded in single-view
              const pag = document.querySelector('.collection-pagination');
              if (pag) pag.hidden = true;

              // If more pages exist, fetch next batch recursively
              const nextBatchGrid = doc.querySelector('.product-grid[data-next-url]');
              if (nextBatchGrid && nextBatchGrid.dataset.nextUrl) {
                loadNextCatalogBatch(nextBatchGrid.dataset.nextUrl);
              } else {
                applyFiltersAndSort(false);
              }
            }
          })
          .catch(err => console.warn('Catalog batch load error:', err));
      };
      loadNextCatalogBatch(grid.dataset.nextUrl);
    }
  };

  initCollectionFilters();


  const recentlyViewed = document.querySelector('[data-recently-viewed]');
  if (recentlyViewed) {
    try {
      const current = JSON.parse(recentlyViewed.dataset.currentProduct);
      const key = 'boxyCrewRecentlyViewed';
      const stored = JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item.handle !== current.handle && item.url && item.title);
      const grid = recentlyViewed.querySelector('[data-recently-viewed-grid]');
      if (stored.length && grid) {
        grid.innerHTML = stored.slice(0, 4).map((item) => `<a class="recent-card" href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy">` : ''}<span><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.price || '')}</small></span></a>`).join('');
        recentlyViewed.hidden = false;
      }
      localStorage.setItem(key, JSON.stringify([current, ...stored].slice(0, 8)));
    } catch (error) { /* Storage may be unavailable in privacy mode. */ }
  }

  const bundleBuilder = document.querySelector('[data-bundle-builder]');
  if (bundleBuilder) {
    const quantityButtons = bundleBuilder.querySelectorAll('[data-bundle-quantity]');
    const sizeSelect = bundleBuilder.querySelector('[data-bundle-size]');
    const productButtons = bundleBuilder.querySelectorAll('[data-bundle-product]');
    const categoryButtons = bundleBuilder.querySelectorAll('[data-bundle-category]');
    const categoryApply = bundleBuilder.querySelector('[data-bundle-category-apply]');
    const categoryClear = bundleBuilder.querySelector('[data-bundle-category-clear]');
    const waistbandWrap = bundleBuilder.querySelector('[data-bundle-waistband-filters]');
    const waistbandButtons = bundleBuilder.querySelectorAll('[data-bundle-waistband]');
    const stepItems = bundleBuilder.querySelectorAll('.bundle-steps .step-item');
    const setActiveStep = (n) => { stepItems.forEach((s, i) => s.classList.toggle('is-active', i < n)); };
    const progress = bundleBuilder.querySelector('[data-bundle-progress]');
    const status = bundleBuilder.querySelector('[data-bundle-status]');
    const review = bundleBuilder.querySelector('[data-bundle-review]');
    const addButtons = [...bundleBuilder.querySelectorAll('[data-bundle-add]')];
    const dock = bundleBuilder.querySelector('[data-bundle-dock]');
    const dockSavings = bundleBuilder.querySelector('[data-bundle-savings]');
    const totalLabel = bundleBuilder.querySelector('[data-bundle-total]');
    let selectedQuantity = 0;
    let selectedSize = '';
    const selectedItems = new Map();
    let singleReferencePrice = 0;
    let activeWaistband = 'all';
    let appliedCategories = new Set();
    let bundleSubmitting = false;
    const productHasSelectedSize = (button) => {
      if (!selectedSize) return true;
      try {
        const variants = JSON.parse(button.querySelector('[data-bundle-variants]')?.textContent || '[]');
        const wanted = String(selectedSize).trim().toLowerCase();
        return variants.some((variant) => variant.available && [variant.option1, variant.option2, variant.option3, variant.title].some((value) => String(value || '').trim().toLowerCase() === wanted));
      } catch (_) { return false; }
    };
    const applyCategoryFilter = () => {
      const includesBoxers = appliedCategories.size === 0 || appliedCategories.has('boxers');
      if (waistbandWrap) {
        waistbandWrap.hidden = !includesBoxers;
        if (waistbandWrap.hidden) {
          activeWaistband = 'all';
          waistbandButtons.forEach((b) => b.classList.toggle('is-active', b.dataset.bundleWaistband === 'all'));
        }
      }
      productButtons.forEach((btn) => {
        const family = btn.dataset.productFamily || '';
        const matchesCategory = appliedCategories.size === 0 || appliedCategories.has(family);
        const matchesSize = productHasSelectedSize(btn);
        if (family === 'boxers' && !waistbandWrap?.hidden && activeWaistband !== 'all') {
          const wb = (btn.dataset.waistbandType || '').toLowerCase().replace(/[-_]/g, '');
          const target = String(activeWaistband).toLowerCase().replace(/[-_]/g, '');
          const matchesWaistband = wb === target;
          btn.hidden = !(matchesCategory && matchesWaistband && matchesSize);
        } else {
          btn.hidden = !(matchesCategory && matchesSize);
        }
      });
      const removed = [];
      selectedItems.forEach((item, productId) => {
        const button = [...productButtons].find((candidate) => candidate.dataset.productId === productId);
        if (!button || button.hidden) {
          removed.push(item.title);
          selectedItems.delete(productId);
        }
      });
      if (removed.length) {
        showToast(`${removed.join(', ')} no longer matches your filters and was removed.`);
        syncBundle();
      }
    };
    categoryButtons.forEach((button) => button.addEventListener('click', () => {
      button.classList.toggle('is-selected');
      button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
    }));
    categoryClear?.addEventListener('click', () => {
      categoryButtons.forEach((button) => { button.classList.remove('is-selected'); button.setAttribute('aria-pressed', 'false'); });
      appliedCategories = new Set();
      applyCategoryFilter();
      window.dataLayer?.push({ event: 'build_pack_category_filter', category: 'all' });
    });
    categoryApply?.addEventListener('click', () => {
      appliedCategories = new Set([...categoryButtons].filter((button) => button.classList.contains('is-selected')).map((button) => button.dataset.bundleCategory));
      applyCategoryFilter();
      window.dataLayer?.push({ event: 'build_pack_category_filter', category: [...appliedCategories].join(',') || 'all' });
    });
    waistbandButtons.forEach((button) => button.addEventListener('click', () => {
      waistbandButtons.forEach((b) => { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      button.classList.add('is-active'); button.setAttribute('aria-pressed', 'true');
      activeWaistband = button.dataset.bundleWaistband || 'all';
      applyCategoryFilter();
    }));
    applyCategoryFilter();
    productButtons.forEach((btn) => {
      try {
        const vs = JSON.parse(btn.querySelector('[data-bundle-variants]')?.textContent || '[]');
        const available = vs.find((v) => v.available);
        if (available && available.price && singleReferencePrice === 0) {
          const rawPrice = Number(available.price);
          singleReferencePrice = rawPrice > 10000 ? Math.round(rawPrice) : Math.round(rawPrice * 100);
        }
      } catch (_) {}
    });
    const findVariantBySize = (variants, size, optionIndex) => {
      if (!variants?.length) return null;
      const normSize = String(size).trim().toLowerCase();
      let fallback = null;
      for (const variant of variants) {
        if (!variant.available && fallback == null) fallback = variant;
        const vTitle = String(variant.title || '').toLowerCase();
        const vOpt1 = String(variant.option1 || '').toLowerCase();
        const vOpt2 = String(variant.option2 || '').toLowerCase();
        const vOpt3 = String(variant.option3 || '').toLowerCase();
        const allOptions = [vOpt1, vOpt2, vOpt3];
        const exactIndex = typeof optionIndex === 'number' && optionIndex >= 0 && optionIndex < 3;
        if (exactIndex && allOptions[optionIndex] === normSize && variant.available) return variant;
        if (allOptions.includes(normSize) && variant.available) return variant;
        if (vTitle === normSize && variant.available) return variant;
        if (vTitle.includes(` / ${normSize}`) || vTitle.includes(`- ${normSize}`) || vTitle.endsWith(normSize)) {
          if (variant.available) return variant;
        }
      }
      return fallback;
    };
    const syncBundle = () => {
      quantityButtons.forEach((button) => button.classList.toggle('is-active', Number(button.dataset.bundleQuantity) === selectedQuantity));
      productButtons.forEach((button) => button.setAttribute('aria-pressed', String(selectedItems.has(button.dataset.productId))));
      const chosen = selectedItems.size;
      dock?.classList.toggle('is-ready', chosen > 0);
      const itemEntries = [...selectedItems.values()];
      const pricing = calculateBuildPackPricing(itemEntries);
      if (!selectedQuantity) {
        progress.textContent = 'Choose a pack size to begin';
        setActiveStep(1);
      } else if (!selectedSize) {
        progress.textContent = `Pack of ${selectedQuantity}: pick your size`;
        setActiveStep(2);
      } else if (chosen < selectedQuantity) {
        progress.textContent = `${chosen} of ${selectedQuantity} selected`;
        setActiveStep(3);
      } else {
        progress.textContent = `${chosen} of ${selectedQuantity} selected`;
        setActiveStep(4);
      }
      if (!selectedSize) {
        status.textContent = 'Select one size across your pack.';
      } else if (chosen > 0 && chosen < selectedQuantity) {
        const remainingCount = selectedQuantity - chosen;
        status.textContent = `Size ${selectedSize} across every item · Pick ${remainingCount} more for Pack of ${selectedQuantity} combo price.`;
      } else if (chosen === selectedQuantity && selectedQuantity > 0) {
        status.textContent = `Size ${selectedSize} across every item · Combo price applied.`;
      } else {
        status.textContent = `Size ${selectedSize} across every item.`;
      }
      if (itemEntries.length === 0) {
        review.innerHTML = '<span class="bundle-review-empty">Thumbnails appear here as you select.</span>';
      } else {
        review.innerHTML = itemEntries.map((item, i) => `<div class="bundle-review-thumb" data-review-index="${i}">${item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="${escapeHtml(item.title)}">` : ''}<button type="button" class="bundle-thumb-remove" aria-label="Remove item" data-remove-product="${item.productId || i}">×</button></div>`).join('');
      }
      review.querySelectorAll('[data-remove-product]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const key = btn.dataset.removeProduct;
          if (selectedItems.has(key)) selectedItems.delete(key);
          else selectedItems.delete([...selectedItems.keys()][Number(key)] || key);
          syncBundle();
        });
      });
      if (totalLabel) {
        if (pricing.comboPricePaise <= 0) {
          totalLabel.textContent = '—';
        } else if (pricing.savingsPaise > 0) {
          totalLabel.innerHTML = `<s class="bundle-total-compare">${moneyFormatter.format(pricing.singleTotalPaise / 100)}</s> <span>${moneyFormatter.format(pricing.comboPricePaise / 100)}</span>`;
        } else {
          totalLabel.textContent = moneyFormatter.format(pricing.comboPricePaise / 100);
        }
      }
      if (dockSavings && selectedQuantity && itemEntries.length) {
        if (pricing.savingsPaise > 0) {
          dockSavings.hidden = false;
          dockSavings.innerHTML = `<strong>Pack savings</strong> <span>${moneyFormatter.format(pricing.savingsPaise / 100)}</span>`;
        } else dockSavings.hidden = true;
      } else if (dockSavings) dockSavings.hidden = true;
      const canSubmit = !bundleSubmitting && selectedQuantity && selectedSize && chosen === selectedQuantity;
      addButtons.forEach((button) => { button.disabled = !canSubmit; });
    };
    const allowedQuantities = new Set([...quantityButtons].map((b) => Number(b.dataset.bundleQuantity)).filter((n) => Number.isFinite(n) && n > 0));
    quantityButtons.forEach((button) => button.addEventListener('click', () => {
      const qty = Number(button.dataset.bundleQuantity);
      if (!allowedQuantities.has(qty)) { showToast('This pack size is not currently available.'); return; }
      selectedQuantity = qty;
      while (selectedItems.size > selectedQuantity) selectedItems.delete(selectedItems.keys().next().value);
      window.dataLayer?.push({ event: 'build_pack_start', pack_quantity: selectedQuantity });
      syncBundle();
    }));
    sizeSelect?.addEventListener('change', () => {
      const prevSize = selectedSize;
      selectedSize = sizeSelect.value;
      if (!selectedSize) { selectedItems.clear(); syncBundle(); return; }
      const toRemove = [];
      const revalidated = new Map();
      selectedItems.forEach((existing, key) => {
        const btn = [...productButtons].find((p) => p.dataset.productId === key);
        if (!btn) { toRemove.push({ title: existing.title, reason: 'no-product' }); return; }
        let variants = [];
        try { variants = JSON.parse(btn.querySelector('[data-bundle-variants]')?.textContent || '[]'); } catch (_) { toRemove.push({ title: existing.title, reason: 'variant-read' }); return; }
        let optionIndex = null;
        const firstOpt = variants[0];
        if (firstOpt) {
          ['option1', 'option2', 'option3'].forEach((k, idx) => {
            const v = String(firstOpt[k] || '').toLowerCase();
            if (v.includes(selectedSize.toLowerCase()) || ['size', 'waist', 'length'].some((name) => v.includes(name))) optionIndex = idx;
          });
        }
        const variant = findVariantBySize(variants, selectedSize, optionIndex);
        if (!variant || !variant.available) { toRemove.push({ title: existing.title, reason: variant && !variant.available ? 'sold-out' : 'unavailable' }); return; }
        const variantPricePaise = (() => { const raw = Number(variant.price || 0); return raw > 10000 ? Math.round(raw) : Math.round(raw * 100); })();
        const itemData = {
          productId: existing.productId,
          variantId: variant.id,
          title: existing.title,
          handle: btn.dataset.productHandle || existing.handle || '',
          family: btn.dataset.productFamily || existing.family || '',
          sku: variant.sku || existing.sku || '',
          tier: btn.dataset.pricingTier || existing.tier || '',
          image: existing.image,
          price: variantPricePaise
        };
        itemData.tier = detectBuildPackItemTier(itemData);
        revalidated.set(key, itemData);
      });
      if (toRemove.length) {
        const names = toRemove.map((t) => t.title).join(', ');
        showToast(`Size ${selectedSize} is unavailable for: ${names}. Removed from pack.`);
        window.dataLayer?.push({ event: 'build_pack_size_revalidation', removed: toRemove.length, prev_size: prevSize, new_size: selectedSize });
      }
      selectedItems.clear();
      revalidated.forEach((v, k) => selectedItems.set(k, v));
      applyCategoryFilter();
      syncBundle();
    });
    productButtons.forEach((button) => button.addEventListener('click', () => {
      if (button.hidden) return;
      if (!selectedQuantity || !selectedSize) { showToast('Choose your pack size and garment size first.'); return; }
      const productId = button.dataset.productId;
      if (selectedItems.has(productId)) { selectedItems.delete(productId); syncBundle(); return; }
      if (selectedItems.size >= selectedQuantity) { showToast(`Your Pack of ${selectedQuantity} is full. Remove one item to choose another.`); return; }
      let variants = [];
      try { variants = JSON.parse(button.querySelector('[data-bundle-variants]').textContent); } catch (_) { showToast('Unable to load sizes for this product.'); return; }
      let optionIndex = null;
      const firstOpt = variants[0];
      if (firstOpt) {
        ['option1', 'option2', 'option3'].forEach((key, idx) => {
          const val = String(firstOpt[key] || '').toLowerCase();
          if (val.includes(selectedSize.toLowerCase()) || ['size', 'waist', 'length'].some((k) => val.includes(k))) optionIndex = idx;
        });
      }
      const variant = findVariantBySize(variants, selectedSize, optionIndex);
      if (!variant) { showToast(`Size ${selectedSize} is unavailable for this product.`); return; }
      if (!variant.available) { showToast(`Size ${selectedSize} is sold out for this style.`); return; }
      const imageUrl = button.dataset.productImage || button.querySelector('img')?.getAttribute('src') || '';
      const variantPricePaise = (() => { const raw = Number(variant.price || 0); return raw > 10000 ? Math.round(raw) : Math.round(raw * 100); })();
      const itemData = {
        productId,
        variantId: variant.id,
        title: button.querySelector('strong')?.textContent.trim() || 'Bundle item',
        handle: button.dataset.productHandle || '',
        family: button.dataset.productFamily || '',
        sku: variant.sku || '',
        tier: button.dataset.pricingTier || '',
        image: imageUrl,
        price: variantPricePaise
      };
      itemData.tier = detectBuildPackItemTier(itemData);
      selectedItems.set(productId, itemData);
      window.dataLayer?.push({ event: 'bundle_item_add', product_id: productId, variant_id: variant.id, pricing_tier: itemData.tier });
      syncBundle();
    }));
    const addBundleToCart = async () => {
      if (bundleSubmitting || !selectedQuantity || !selectedSize || selectedItems.size !== selectedQuantity) return;
      bundleSubmitting = true;
      addButtons.forEach((button) => { button.disabled = true; });
      const bundleId = `BC-${Date.now()}`;
      const chosenEntries = [...selectedItems.values()];
      const pricing = calculateBuildPackPricing(chosenEntries);
      const formattedPackPrice = moneyFormatter.format(pricing.comboPricePaise / 100);
      const items = chosenEntries.map((item, index) => ({
        id: Number(item.variantId),
        quantity: 1,
        properties: {
          Bundle: bundleBuilder.dataset.bundleName,
          'Pack size': `Pack of ${selectedQuantity}`,
          'Bundle item': `${index + 1} of ${selectedQuantity}`,
          'Pack price': formattedPackPrice,
          _bundle_id: bundleId,
          _pricing_tier: item.tier,
          _bundle_combo_paise: String(pricing.comboPricePaise),
          _bundle_single_paise: String(pricing.singleTotalPaise)
        }
      }));
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (response.ok) {
          window.dataLayer?.push({ event: 'bundle_add_to_cart', bundle_id: bundleId, pack_quantity: selectedQuantity, pack_price: pricing.comboPricePaise / 100 });
          await refreshCart();
          setCartDrawer(true);
          selectedItems.clear();
        } else showToast('Unable to add this pack right now. Check availability and try again.');
      } catch (_) {
        showToast('Unable to add this pack right now. Check your connection and try again.');
      } finally {
        bundleSubmitting = false;
        syncBundle();
      }
    };
    addButtons.forEach((button) => button.addEventListener('click', addBundleToCart));
    syncBundle();
  }

  document.querySelectorAll('[data-event]').forEach((element) => element.addEventListener('click', () => window.dataLayer?.push({ event: element.dataset.event })));
  document.querySelector('[data-begin-checkout]')?.addEventListener('click', () => window.dataLayer?.push({ event: 'begin_checkout' }));

  const companionAllowed = matchMedia('(pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (companionAllowed) {
    const companion = document.createElement('div');
    companion.className = 'cursor-companion';
    companion.setAttribute('aria-hidden', 'true');
    body.appendChild(companion);
    let targetX = -100, targetY = -100, currentX = -100, currentY = -100, previousX = -100, rotation = 0;
    document.addEventListener('pointermove', (event) => { targetX = event.clientX + 13; targetY = event.clientY + 14; companion.classList.add('is-visible'); }, { passive: true });
    document.addEventListener('pointerleave', () => companion.classList.remove('is-visible', 'is-hovering', 'is-on-dark'));
    document.addEventListener('pointerover', (event) => {
      companion.classList.toggle('is-hovering', Boolean(event.target.closest('a, button, input, select, summary, label')));
      companion.classList.toggle('is-on-dark', Boolean(event.target.closest('.section-black, .site-footer, .cart-drawer, .mobile-nav, [data-dark-surface]')));
    });
    const animate = () => {
      currentX += (targetX - currentX) * .17; currentY += (targetY - currentY) * .17;
      const velocity = currentX - previousX; rotation += (Math.max(-12, Math.min(12, velocity * 1.6)) - rotation) * .2; previousX = currentX;
      companion.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) rotate(${rotation}deg)`;
      requestAnimationFrame(animate);
    };
    animate();
  }
})();

/* Compact Judge.me rating links for product pages and collection cards. */
(() => {
  const reviewInfo = (root) => {
    const header = root && root.querySelector('[data-number-of-reviews]');
    if (!header) return null;
    const count = Number(header.dataset.numberOfReviews || 0);
    const average = Number(header.dataset.averageRating || 0);
    return count > 0 && average > 0 ? { count, average } : null;
  };

  const badge = ({ count, average }, href) => {
    const reviewLabel = `${count} ${count === 1 ? 'review' : 'reviews'}`;
    return `<a class="boxy-review-badge" href="${href}" aria-label="${average.toFixed(1)} out of 5 from ${reviewLabel}"><span class="boxy-review-badge__stars" aria-hidden="true">★★★★★</span><span>${average.toFixed(1)}</span><span class="boxy-review-badge__count">(${reviewLabel})</span></a>`;
  };

  const setProductBadge = () => {
    const target = document.querySelector('.product-rating-row');
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!target || !widget || target.dataset.boxyReady === 'true') return;
    const info = reviewInfo(widget);
    if (!info) return;
    target.innerHTML = badge(info, '#ProductReviews');
    target.dataset.boxyReady = 'true';
  };

  const setCardBadges = () => {
    document.querySelectorAll('[data-product-card-rating]').forEach((target) => {
      if (target.dataset.boxyReady === 'true') return;
      const source = target.parentElement && target.parentElement.querySelector('template[data-product-review-source]');
      const info = source && reviewInfo(source.content);
      const card = target.closest('.product-card');
      const link = card && card.querySelector('h3 a');
      if (!info || !link) return;
      target.innerHTML = badge(info, `${link.href}#ProductReviews`);
      target.dataset.boxyReady = 'true';
    });
  };

  const run = () => { setProductBadge(); setCardBadges(); };
  run();
  document.addEventListener('judgeme:loaded', run);
  window.addEventListener('load', run, { once: true });
  setTimeout(run, 1200);
})();

(() => {
  const popup = document.querySelector('[data-mystery-popup]');
  if (!popup) return;
  const sessionKey = 'boxyMysteryPopupSeen';
  const frequencyKey = 'boxyMysteryPopupLastSeen';
  const subscribedKey = 'boxyMysterySubscribed';
  const frequencyWindow = 3 * 24 * 60 * 60 * 1000;
  let shown = false;
  try {
    if (sessionStorage.getItem(sessionKey) || localStorage.getItem(subscribedKey)) return;
    const lastSeen = Number(localStorage.getItem(frequencyKey) || 0);
    if (lastSeen && Date.now() - lastSeen < frequencyWindow) return;
  } catch (_) {}
  const close = () => {
    if (typeof popup.close === 'function' && popup.open) popup.close();
    else popup.removeAttribute('open');
  };
  const show = () => {
    if (shown || popup.open) return;
    shown = true;
    try {
      sessionStorage.setItem(sessionKey, '1');
      localStorage.setItem(frequencyKey, String(Date.now()));
    } catch (_) {}
    if (typeof popup.showModal === 'function') popup.showModal();
    else popup.setAttribute('open', '');
  };
  popup.querySelector('[data-mystery-popup-close]')?.addEventListener('click', close);
  popup.addEventListener('click', (event) => { if (event.target === popup) close(); });
  popup.querySelector('form')?.addEventListener('submit', () => {
    try { localStorage.setItem(subscribedKey, '1'); } catch (_) {}
  });
  const delay = Math.max(5000, Number(popup.dataset.delay || 10000));
  const timer = setTimeout(show, delay);
  const onScroll = () => {
    const available = document.documentElement.scrollHeight - innerHeight;
    if (available > 0 && scrollY / available >= .35) {
      clearTimeout(timer);
      show();
      removeEventListener('scroll', onScroll);
    }
  };
  addEventListener('scroll', onScroll, { passive: true });
})();



(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const isNarrow = () => window.innerWidth < 900;
  const initSection = (section) => {
    if (section.bcInit) return;
    section.bcInit = true;
    const viewport = section.querySelector('[data-carousel-viewport]');
    const track = section.querySelector('[data-carousel-track]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    const dotsWrap = section.querySelector('[data-carousel-dots]');
    if (!viewport || !track) return;
    const timers = { auto: null, resume: null, paused: false };
    section.bcTimers = timers;
    const loop = section.getAttribute('data-loop') === '1';
    const update = () => {
      const desktopVisible = parseInt(section.getAttribute('data-desktop-visible') || '4', 10);
      const mobileVisible = parseInt(section.getAttribute('data-mobile-visible') || '2', 10);
      const narrow = isNarrow();
      const visibleCount = narrow ? mobileVisible : desktopVisible;
      const items = Array.from(track.querySelectorAll('.card-carousel-item'));
      if (!items.length) return;
      const gap = parseFloat(getComputedStyle(section).getPropertyValue('--cc-gap')) || 12;
      const viewportW = viewport.clientWidth;
      const cardW = Math.max(40, (viewportW - (gap * (visibleCount - 1))) / visibleCount);
      track.style.setProperty('--cc-card-w', `${cardW}px`);
      track.style.setProperty('--cc-card-count', String(items.length));
      track.style.setProperty('--cc-visible', String(visibleCount));
      items.forEach((el) => { el.style.flex = `0 0 ${cardW}px`; el.style.width = `${cardW}px`; });
      const sl = viewport.scrollLeft;
      if (prevBtn) prevBtn.disabled = !loop && sl <= 2;
      if (nextBtn) nextBtn.disabled = !loop && sl + viewport.clientWidth + 2 >= track.scrollWidth;
      const pageSize = cardW + gap;
      const stepCount = 1;
      const pageCount = Math.max(1, Math.ceil(Math.max(0, (items.length - visibleCount)) / stepCount) + 1);
      if (dotsWrap) {
        const existing = dotsWrap.querySelectorAll('button');
        if (existing.length !== pageCount) {
          dotsWrap.innerHTML = '';
          for (let i = 0; i < pageCount; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', `Go to page ${i + 1}`);
            b.setAttribute('role', 'tab');
            b.dataset.page = String(i);
            b.addEventListener('click', () => {
              const target = i * pageSize;
              try { viewport.scrollTo({ left: target, behavior: 'smooth' }); } catch (_) { viewport.scrollLeft = target; }
              scheduleResume();
            });
            dotsWrap.appendChild(b);
          }
        }
        const currentPage = Math.min(pageCount - 1, Math.round(sl / Math.max(1, pageSize)));
        dotsWrap.querySelectorAll('button').forEach((b, i) => {
          b.classList.toggle('is-active', i === currentPage);
          b.setAttribute('aria-selected', i === currentPage ? 'true' : 'false');
        });
      }
    };
    const scheduleResume = () => {
      clearTimeout(timers.resume);
      timers.paused = true;
      const delay = parseInt(section.getAttribute('data-resume') || '4500', 10);
      timers.resume = setTimeout(() => { timers.paused = false; }, delay);
    };
    const step = (dir) => {
      const desktopVisible = parseInt(section.getAttribute('data-desktop-visible') || '4', 10);
      const mobileVisible = parseInt(section.getAttribute('data-mobile-visible') || '2', 10);
      const narrow = isNarrow();
      const visibleCount = narrow ? mobileVisible : desktopVisible;
      const gap = parseFloat(getComputedStyle(section).getPropertyValue('--cc-gap')) || 12;
      const viewportW = viewport.clientWidth;
      const cardW = Math.max(40, (viewportW - (gap * (visibleCount - 1))) / visibleCount);
      const stepBy = 1;
      const delta = (cardW + gap) * stepBy;
      const maxSL = Math.max(0, track.scrollWidth - viewport.clientWidth);
      if (dir > 0) {
        if (loop && viewport.scrollLeft + viewport.clientWidth + 2 >= track.scrollWidth) {
          try { viewport.scrollTo({ left: 0, behavior: 'smooth' }); } catch (_) { viewport.scrollLeft = 0; }
        } else {
          const target = viewport.scrollLeft + delta;
          try { viewport.scrollTo({ left: Math.min(maxSL, target), behavior: 'smooth' }); } catch (_) { viewport.scrollLeft = Math.min(maxSL, target); }
        }
      } else {
        if (loop && viewport.scrollLeft <= 2) {
          try { viewport.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); } catch (_) { viewport.scrollLeft = track.scrollWidth; }
        } else {
          const target = viewport.scrollLeft - delta;
          try { viewport.scrollTo({ left: Math.max(0, target), behavior: 'smooth' }); } catch (_) { viewport.scrollLeft = Math.max(0, target); }
        }
      }
      scheduleResume();
    };
    if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => step(1));
    if (viewport) {
      const evtOpts = { passive: true };
      viewport.addEventListener('scroll', update, evtOpts);
      ['pointerdown','pointermove','touchstart','touchmove','keydown','focusin','wheel'].forEach((evt) => {
        viewport.addEventListener(evt, scheduleResume, evtOpts);
      });
      viewport.addEventListener('pointerenter', scheduleResume, evtOpts);
      viewport.addEventListener('pointerleave', () => { timers.paused = false; }, evtOpts);
    }
    document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleResume(); });
    if (!reduceMotion.matches && section.getAttribute('data-auto') === '1') {
      const interval = Math.max(800, parseInt(section.getAttribute('data-interval') || '2000', 10));
      timers.auto = setInterval(() => {
        if (!isNarrow()) return;
        if (document.hidden) return;
        if (timers.paused) return;
        step(1);
      }, interval);
    }
    update();
    requestAnimationFrame(update);
  };
  const run = () => document.querySelectorAll('[data-card-carousel]').forEach(initSection);
  run();
  addEventListener('resize', run, { passive: true });
  addEventListener('orientationchange', run, { passive: true });
  document.addEventListener('shopify:section:load', run);
})();

/* ==========================================================================
   PDP Enhancements: Description Collapsible, Review Images & Form Trigger
   ========================================================================== */
(() => {
  // 1. Collapsible Product Description (Clamped to 5-6 lines with "More" / "Less")
  const initDescriptionToggle = () => {
    const containers = document.querySelectorAll('[data-collapsible-description]');
    containers.forEach((container) => {
      const content = container.querySelector('[data-description-content]');
      const toggleBtn = container.querySelector('[data-description-toggle]');
      if (!content || !toggleBtn || container.dataset.initialized === 'true') return;

      // Allow DOM to settle before measuring
      requestAnimationFrame(() => {
        const fullHeight = content.scrollHeight;
        // ~5 to 6 lines of text is approximately 130px - 140px
        const maxCollapsedHeight = 135;

        if (fullHeight > maxCollapsedHeight) {
          content.classList.add('is-clamped');
          toggleBtn.style.display = 'inline-flex';

          toggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const isClamped = content.classList.contains('is-clamped');
            if (isClamped) {
              content.classList.remove('is-clamped');
              content.classList.add('is-expanded');
              toggleBtn.setAttribute('aria-expanded', 'true');
            } else {
              content.classList.remove('is-expanded');
              content.classList.add('is-clamped');
              toggleBtn.setAttribute('aria-expanded', 'false');
              // Smooth scroll back to description header if user scrolled far down
              container.closest('details')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });
        } else {
          toggleBtn.style.display = 'none';
        }
        container.dataset.initialized = 'true';
      });
    });
  };

  // 2. Fast Review Image Hydration (instantly promote data-src to src & remove spinner)
  const hydrateReviewImages = () => {
    const reviewWidget = document.querySelector('#judgeme_product_reviews');
    if (!reviewWidget) return;

    const imgs = reviewWidget.querySelectorAll('img[data-src], .jdgm-rev__pic-img');
    imgs.forEach((img) => {
      const dataSrc = img.getAttribute('data-src');
      if (dataSrc) {
        if (!img.src || img.src !== dataSrc) {
          img.src = dataSrc;
        }
        img.removeAttribute('data-src');
      }
      img.style.opacity = '1';
      img.style.display = 'block';

      const parentLink = img.closest('.jdgm-rev__pic-link');
      if (parentLink) {
        parentLink.classList.remove('jdgm--loading');
        parentLink.classList.add('jdgm--loaded');
      }
    });
  };

  // 3. Create / Write Review Trigger
  const initReviewFormTrigger = () => {
    document.querySelectorAll('[data-trigger-review-form]').forEach((btn) => {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const reviewsSection = document.getElementById('ProductReviews');
        if (reviewsSection) {
          reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Trigger Judge.me's native write review link
        const nativeLink = document.querySelector('#judgeme_product_reviews .jdgm-write-rev-link');
        if (nativeLink) {
          nativeLink.style.display = 'inline-flex';
          nativeLink.click();
        }

        // If Judge.me hasn't attached the form yet, load form.js and open form
        if (window.jdgm) {
          if (typeof window.jdgm.loadScript === 'function' && (!window.jdgm.openForm || !document.querySelector('.jdgm-form-wrapper'))) {
            window.jdgm.loadScript((window.jdgm.CDN_HOST || 'https://cdnwidget.judge.me/') + 'widget/form.js', () => {
              const widgetEl = document.querySelector('#judgeme_product_reviews');
              if (widgetEl && window.jdgm.openForm && window.jQuery) {
                window.jdgm.openForm(window.jQuery(widgetEl));
              }
            });
          } else if (typeof window.jdgm.openForm === 'function') {
            const widgetEl = document.querySelector('#judgeme_product_reviews');
            if (widgetEl && window.jQuery) {
              window.jdgm.openForm(window.jQuery(widgetEl));
            }
          }
        }
      });
    });
  };

  /* --------------------------------------------------------------------------
     Desktop PDP Sticky Product Summary
     -------------------------------------------------------------------------- */
  const initPdpSticky = () => {
    const summary = document.querySelector('.product-summary[data-product-summary]');
    const header = document.querySelector('.site-header');
    if (!summary) return;

    const updateHeaderHeight = () => {
      if (header) {
        const h = header.getBoundingClientRect().height;
        if (h > 0) {
          document.documentElement.style.setProperty('--site-header-height', `${Math.round(h)}px`);
        }
      }
    };
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
    window.addEventListener('orientationchange', updateHeaderHeight, { passive: true });
  };

  // Run on load and observe dynamically rendered review widget updates
  const setupPDP = () => {
    initDescriptionToggle();
    hydrateReviewImages();
    initReviewFormTrigger();
    initPdpSticky();

    // Observe Judge.me widget for dynamic reviews injection / pagination
    const reviewWidget = document.querySelector('#judgeme_product_reviews');
    if (reviewWidget && window.MutationObserver) {
      const observer = new MutationObserver(() => {
        hydrateReviewImages();
        initReviewFormTrigger();
      });
      observer.observe(reviewWidget, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupPDP);
  } else {
    setupPDP();
  }
  window.addEventListener('load', setupPDP, { once: true });
  document.addEventListener('shopify:section:load', () => {
    pdpStickyInitialized = false;
    setupPDP();
  });
  document.addEventListener('judgeme:loaded', () => {
    hydrateReviewImages();
    initReviewFormTrigger();
  });
})();
